import { DownloadOutlined } from '@ant-design/icons'
import { Empty, Spin } from 'antd'
import KButton from 'app/components/Modules/General/KButton'
import { ToolBox } from 'app/lib/hooks/toolBox'
import CapacitorService from 'app/lib/services/CapacitorService'
import { useState } from 'react'
import * as React from 'react'
import { isAndroid } from 'react-device-detect'

type Props = {
  src: string
  recordType?: string
  action?: string
  downloadButtonTitle?: string
}

const KIFrame: React.FC<Props> = ({
  src,
  action = 'download',
  recordType,
  downloadButtonTitle
}) => {
  const { tComponent } = ToolBox.useString()
  const [loading, setLoading] = useState<boolean>(Boolean(src))

  const isAndroidDevice = () => CapacitorService.isAndroid() || isAndroid

  const onClick = (): void => {
    window.open(src)
  }

  const onLoad = (): void => {
    setLoading(false)
  }

  return (
    <Spin spinning={loading}>
      <Choose>
        <When condition={src}>
          <div className="antd-iframe">
            <iframe
              src={
                isAndroidDevice() ? `http://docs.google.com/gview?url=${src}&embedded=true` : src
              }
              title={src}
              onLoad={onLoad}
            />
            <KButton
              recordType={recordType}
              action={action}
              onClick={onClick}
              type="primary"
              shape="round"
              title={downloadButtonTitle}
              icon={<DownloadOutlined />}
            />
          </div>
        </When>
        <Otherwise>
          <div className="empty-container py-2">
            <Empty
              description={tComponent({
                recordType,
                componentType: 'data_display',
                componentName: 'iframe',
                id: 'empty_message'
              })}
            />
          </div>
        </Otherwise>
      </Choose>
    </Spin>
  )
}

export default KIFrame
